import React, { useState } from 'react';
import { Spinner } from '@cimpress/react-components';

import idGeneratorAtor from 'src/util/idGeneratorAtor';
import FileUpload from './FileUpload';

const idGenerator = idGeneratorAtor('uploadButton');

interface UploadButtonProps {
    className?: string;
    label?: string;
    accept?: string;
    hide?: boolean;
    uploaded?: boolean;
    uploading?: boolean;
    disabled?: boolean;
    multiple?: boolean;
    buttonType?: string;
    onUpload: React.ChangeEventHandler<HTMLInputElement>;
    testid?: string;
}

const UploadButton: React.FC<UploadButtonProps> = (props) => {
    const { label, hide, uploaded, uploading, onUpload, className, buttonType, accept, disabled, multiple, testid } =
        props;
    const [uniqueId] = useState(() => idGenerator().replace(' ', ''));

    if (hide) {
        return null;
    }
    const type = buttonType || 'default';
    return (
        <div
            className={`upload-button ${className}${uploaded ? ' upload-button--uploaded' : ''}${uploading ? ' upload-button--uploading' : ''}`}>
            <label htmlFor={uniqueId} className={`btn btn-${type}${disabled ? ' disabled' : ''}`}>
                {label}
            </label>
            <Spinner className='upload-button__spinner centerSpinner' size='medium' />
            <FileUpload
                testid={testid}
                id={uniqueId}
                onChange={onUpload}
                disabled={disabled || uploading}
                accept={accept}
                multiple={multiple}
            />
        </div>
    );
};

export default React.memo(UploadButton);
